import { Contract, ContractHelper } from '@ecm/portfolio';

export class TmsHelper {
    /**
     * Get mix of contracts for TMS (property `mixte_contrat`)
     * @param {Contract[]} contracts Contracts array from /portfolio API
     * @returns {string | undefined}
     */
    public static getMixedContracts(contracts: Contract[]): string | undefined {
        const isEligibleContract = (contract: Contract): boolean =>
            !['RESILIE', 'CLOS', 'RETRACTE'].includes(contract.status) &&
            contract.telco?.state !== 'SUGGESTED' &&
            contract.telco?.type?.toLowerCase() !== 'pro' &&
            contract.vertical !== 'SECURITE';

        const eligible = contracts.filter(isEligibleContract);

        if (eligible.length === 0) {
            return undefined;
        }

        if (eligible.length > 1) {
            return 'multi-contrats';
        }

        const contract = eligible[0];

        if (contract.telco?.subType === 'parnasse') {
            return 'mono-parnasse';
        }
        if (ContractHelper.isInternet(contract) || ContractHelper.isOpen(contract)) {
            return 'mono-internet';
        }
        if (ContractHelper.isLandline(contract)) {
            return 'mono-fixe';
        }
        if (ContractHelper.isMobile(contract)) {
            return 'mono-mobile';
        }

        return 'mono';
    }

    /**
     * Get linked contracts for TMS (property `compte_rattaches`)
     * @param {Contract[]} contracts Contracts array from /portfolio API
     * @returns {string}
     */
    public static getLinkedContracts(contracts: Contract[]): string {
        const shortTypes = { internet: 'I', fixe: 'F', open: 'IM' };
        return contracts
            .filter((contract) => contract.telco?.type && contract.telco.state !== 'SUGGESTED')
            .map((contract): string => {
                const contractType = contract.telco.type.toLowerCase();
                return ContractHelper.isMobile(contract) ? 'M' : shortTypes[contractType] || '';
            })
            .filter((shortType) => shortType !== '')
            .join('+');
    }

    /**
     * format Label for trackLink by replacing accented characters and blank by "_"
     * @param {string} label
     * @returns {string}
     */
    public static getFormattedLabel(label: string): string {
        return label
            .toLowerCase()
            .replace(/'/g, '_')
            .replace(/ /g, '_')
            .replace(/[àâä]/g, 'a')
            .replace(/[ç]/g, 'c')
            .replace(/[èéêë]/g, 'e')
            .replace(/[îï]/g, 'i')
            .replace(/[ôö]/g, 'o')
            .replace(/[ùûü]/g, 'u');
    }
}
